import axios from 'axios'
import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import 'aos/dist/aos.css'
import router from './router'
import store from './store'

// axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'https://shielded-meadow-10836.herokuapp.com/api'
axios.defaults.baseURL = 'https://husky-task-9b427983dbcd.herokuapp.com/api'
// axios.defaults.baseURL = 'http://localhost:8000/api'

// Add response interceptor to handle authentication errors
axios.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response
  },
  (error) => {
    // Handle error responses
    if (error.response) {
      const status = error.response.status
      // Check for 401 (Unauthorized) or 403 (Forbidden) status codes
      if ((status === 401 || status === 403) && !(error.config && error.config.skipAuthRedirect)) {
        // Get current route to avoid redirect loops
        const currentRoute = router.currentRoute.value
        const publicPages = ['/login', '/register', '/success', '/', '/verified', '/privacy-policy', '/join-wait-list', '/tasker', '/owner', '/services', '/search']
        const isPublicPage = publicPages.includes(currentRoute.path)

        // Only clear auth and redirect if trying to access a protected resource
        // If on a public page, clear auth but don't redirect (let the page handle it)
        if (!isPublicPage) {
          // Clear user authentication data
          localStorage.removeItem('sa_user')

          // Dispatch logout action to clear Vuex state
          if (store && store.dispatch) {
            store.dispatch('auth/logout').catch(() => {
              // Ignore errors if logout fails
            })
          }

          // Redirect to login page
          if (currentRoute.name !== 'Login') {
            router.push({ name: 'Login' })
          }
        }
      }
    }
    // Return the error so it can be handled by the calling code
    return Promise.reject(error)
  }
)

const app = createApp(App)

app.use(store)
app.use(router)
app.mount('#app')
